import { gql } from '__generated__';

export const GET_AI_POLICY_INFO = gql(/* GraphQL */ `
  query GetAiPolicyInfo {
    getAiPolicyInfo {
      currentVersion
      policyText
      userAcceptedVersion
    }
  }
`);
